<template>
  <div ref="playContainer" class="flex flex-col h-screen max-h-screen bg-white">

    <!-- status bar at the top -->
    <div :style="currentQuestion ? 'grid-template-columns: 1fr 1fr 1fr 1fr' : 'grid-template-columns: 1fr'"
         class="p-4 grid gap-4">

      <!-- prevent quiz logo -->
      <div v-if="currentQuestion" class="h-full flex justify-center items-center">
        <img class="w-full" src="../assets/prev-quiz-title.svg">
      </div>

      <!-- quiz is starting soon or is over-->
      <div v-if="!currentQuestion" class="custom-card h3 text-center m-0">
        {{ quiz.currentQuestion < 0 ? 'Das Quiz startet gleich...' : 'Danke fürs Mitspielen!' }}
      </div>

      <!-- current question -->
      <div v-else class="custom-card-highlight h3 m-0 text-center">
        Frage {{ quiz.currentQuestion + 1 }} von {{ quiz.questions.length }}
      </div>

      <!-- current state -->
      <!--div v-if="currentQuestion" class="custom-card h3 flex flex-row items-center justify-around m-0">
        <font-awesome-icon :icon="['fas', 'question-circle']" class="" />
        <font-awesome-icon :icon="['fas', 'chevron-right']" class="text-gray-300" />
        <font-awesome-icon :class="questionState < 2 && 'text-gray-300'" :icon="['fas', 'check-square']"
                           class="z-20 inline" />
        <font-awesome-icon :icon="['fas', 'chevron-right']" class="text-gray-300" />
        <font-awesome-icon :class="questionState < 3 && 'text-gray-300'" :icon="['fas', 'clock']" class="z-20 inline" />
        <font-awesome-icon :icon="['fas', 'chevron-right']" class="text-gray-300" />
        <font-awesome-icon :class="questionState < 4 && 'text-gray-300'" :icon="['fas', 'poll-h']"
                           class="z-20 inline" />
      </div-->

      <!-- progress bar -->
      <div v-if="currentQuestion" class="custom-card relative overflow-hidden h3" style="border-color: transparent;">
        <font-awesome-icon :icon="['fas', 'user-check']" class="mr-6 z-20 relative inline" />
        <span class="z-20 relative">{{ Math.round(percentVoted * 100) }}% Abgestimmt</span>
        <div :style="{width: (percentVoted * 100) + '%'}"
             class="absolute top-0 left-0 h-full bg-gray-200 z-10 transition-all duration-200" />
      </div>

      <!-- timer -->
      <div :class="timer.start && (timer.currentValue < 10 ? 'red-bg' : 'orange-bg')" v-if="currentQuestion"
           class="custom-card h3 m-0 text-white">
        <font-awesome-icon :icon="['fas', 'clock']" class="mr-6 inline" />
        <span v-if="timer.start">{{ timer.currentValue }} s</span>
        <span v-else>-</span>
      </div>
    </div>

    <!-- question content and options -->
    <div v-if="currentQuestion"
         :style="currentQuestion.options.length <= 4 ? 'grid-template-columns: 66fr 33fr' : 'grid-template-columns: 50fr 50fr'"
         class="flex-grow p-4 pt-0 grid gap-4">

      <!-- question content -->
      <div class="custom-card flex flex-col relative overflow-hidden">
        <p class="h2 relative z-20">{{ currentQuestion.title }}</p>

        <p class="absolute z-10 bottom-0 right-0 transform rotate-12 mr-16 -mb-32 font-extrabold text-gray-100"
           style="font-size: 600px;">?</p>

        <img v-if="questionMediaObject && questionMediaObject.meta.contentType.includes('image')"
             :alt="questionMediaObject.alt" :src="questionMediaObject.url" class="w-auto h-16 flex-grow relative z-20"
             style="width: fit-content">

        <video v-if="questionMediaObject && questionMediaObject.meta.contentType.includes('video')" ref="video"
               :src="questionMediaObject.url" class="w-auto h-16 flex-grow relative z-20" controls
               style="width: fit-content" />

      </div>

      <div :class="currentQuestion.options.length <= 4 ? 'grid-cols-1' : 'grid-cols-2 grid-flow-col grid-rows-4'"
           class="grid gap-4 ">
        <!-- options -->
        <div v-for="(option, index) in currentQuestion.options"
             class="custom-card flex flex-row items-center justify-items-start z-20 relative overflow-hidden">

          <!-- number -->
          <span v-if="questionState >= 2"
                class="w-10 h-10 bg-gray-800 h3 text-white font-bold flex-shrink-0 bg-white rounded-full inline-flex justify-center items-center mr-4 relative z-20">
          {{ index + 1 }}
          </span>

          <!-- content -->
          <span v-if="questionState >= 2" class="z-20 relative h4">
          {{
              option + (questionState === 4 && votesForCurrentQuestion.length ? ': ' + Math.round(votesForCurrentQuestion.filter(v => v.option === option).length / votesForCurrentQuestion.length * 100) + '%' : '')
            }}
          </span>

          <!-- percent of votes in background -->
          <div v-if="questionState === 4"
               :class="(currentQuestion.correct === index || currentQuestion.type === QUESTION_TYPES.EXPERIENCE) && questionState >= 4 ? 'bg-green' : 'bg-red-300'"
               :style="{width: (votesForCurrentQuestion.filter(v => v.option === option).length / votesForCurrentQuestion.length * 100) + '%'}"
               class="absolute top-0 left-0 w-full h-full z-10 appear-to-right rounded-l-xl" />

          <!-- green outer marking -->
          <div
              :class="currentQuestion.correct === index && currentQuestion.type === QUESTION_TYPES.KNOWLEDGE && questionState >= 4 && 'green-inner-shadow'"
              class="absolute top-0 left-0 w-full h-full z-20 rounded-xl" />
        </div>
      </div>

    </div>

    <div v-else class="flex-grow flex flex-col justify-center items-center">
      <img class="h-48" src="../assets/prev-quiz-icon.svg">
      <img class="h-32" src="../assets/prev-quiz-title.svg">
    </div>

    <!-- status bar at the bottom -->
    <div class="flex flex-row justify-center items-center p-4 pt-0 gap-4">

      <!-- open and close fullscreen -->
      <button class="button flex-shrink-0" @click="changeFullscreen">
        <font-awesome-icon v-if="!fullscreen" :icon="['fas', 'expand']" size="lg" />
        <font-awesome-icon v-else :icon="['fas', 'compress']" size="lg" />
      </button>

      <!-- go to dashboard button -->
      <button class="button flex-shrink-0" style="color: rgb(59, 67, 81) !important;"
              @click="(fullscreen && changeFullscreen()); $router.push('/dashboard')">
        <font-awesome-icon :icon="['fas', 'home']" size="lg" />
      </button>

      <!-- arrow left -->
      <button class="button flex-shrink-0" @click="goSteps(-1)">
        <font-awesome-icon :icon="['fas', 'chevron-left']" size="lg" />
      </button>

      <!-- arrow right -->
      <button class="button flex-shrink-0" @click="goSteps()">
        <font-awesome-icon :icon="['fas', 'chevron-right']" size="lg" />
      </button>

      <!-- show qr code -->
      <button class="button flex-shrink-0" @click="qrOpen = true;">
        <font-awesome-icon :icon="['fas', 'qrcode']" size="lg" />
      </button>

      <!-- show leaderboard -->
      <button class="button flex-shrink-0" @click="leaderboardOpen = true;">
        <font-awesome-icon :icon="['fas', 'star']" size="lg" />
      </button>

    </div>

    <!-- close overlay buttton -->
    <button v-if="qrOpen || leaderboardOpen" class="fixed top-0 right-0 z-60 p-4 rounded-3xl"
            @click="qrOpen = false; leaderboardOpen = false;">
      <font-awesome-icon :icon="['fas', 'times']" class="text-white z-60" size="2x" />
    </button>

    <!-- qr-code and members -->
    <div v-show="qrOpen" class="popup-background">

      <!-- qr-code -->
      <div class="custom-card">
        <p class="h1 text-center">Am Quiz teilnehmen</p>
        <vue-qr :size="900" :text="url(true)" class="max-h-23 mx-auto" colorDark="rgb(59, 67, 81)"
                style="display: block !important;" />
        <p class="h2 mt-4 mb-0 text-bold">{{ url(false) }}</p>
      </div>

      <!-- members -->
      <div class="custom-card max-h-full flex flex-col">
        <p class="h2">Teilnehmer</p>
        <ul class="list-decimal list-inside">
          <li v-for="player in $store.state.play.players">
            {{ player.id }}
          </li>
        </ul>

        <!-- no members yet -->
        <p v-if="!$store.state.play.players.length">
          Noch keine Mitglieder hier. Wo bleibt ihr? </p>
      </div>

    </div>

    <!-- leaderboard -->
    <div v-show="leaderboardOpen" class="popup-background max-h-screen p-4">

      <div class="custom-card w-1/2 max-h-full flex flex-col">
        <div class="h1">
          Bestenliste
          <button class="btn float-right mt-3" @click="shareLeaderboard">
            <span class="inline-block mx-4">Mit Spielern teilen</span>
          </button>
        </div>
        <leaderboard :leaderboard="leaderboard" />
      </div>

    </div>

  </div>
</template>
<script>
import VueQr from "vue-qr";
import { quizCollection } from "../plugins/firebase";
import hotkeys from 'hotkeys-js';
import { QUESTION_TYPES } from "./EditQuiz";
import { leaderboard } from "../store/play";
import Leaderboard from "../components/Leaderboard";

export default {
  data() {
    return {
      QUESTION_TYPES,
      qrOpen: false,
      leaderboardOpen: false,
      fullscreen: false,
      audio: null,
      questionState: 0, // 0 = showing content, 1 = starting videos, 2 = showing options, 3 = timer & voting running, 4 = showing results
      timer: {
        start: 0,
        currentValue: 0,
        duration: 0,
        interval: null,
      }
    }
  },
  created() {
    this.$store.dispatch("loadPlayers", this.quiz);
    this.$store.dispatch("loadVotes", this.quiz);

    // set current question
    if (this.quiz.currentQuestion == null)
      quizCollection.doc(this.quiz.id).update({
        currentQuestion: -1
      });

    if (!this.currentQuestion)
      this.qrOpen = true;

    // listen for arrow hotkeys
    hotkeys('left', () => this.goSteps(-1));
    hotkeys('PageUp', () => this.goSteps(-1));
    hotkeys('right', () => this.goSteps());
    hotkeys('PageDown', () => this.goSteps());
  },
  beforeDestroy() {
    if (this.audio)
      this.audio.pause();
    hotkeys.unbind();
  },
  computed: {
    quiz() {
      return this.$store.state.quiz.quizzes.filter(quiz => quiz.id === this.$route.params.id)[0]
    },
    currentQuestion() {
      if (this.quiz.currentQuestion < 0)
        return null;
      return this.quiz.questions[this.quiz.currentQuestion];
    },
    questionMediaObject() {
      return this.$store.state.media.mediaFiles.filter(media => media.ref.fullPath === this.currentQuestion.media)[0];
    },
    votesForCurrentQuestion() {
      return this.$store.state.play.votes.filter(vote => vote.question === this.quiz.currentQuestion);
    },
    percentVoted() {
      if (this.$store.state.play.players.length === 0)
        return 0;
      return this.votesForCurrentQuestion.length / this.$store.state.play.players.length;
    },
    timerSoundMediaObject() {
      const sound = (this.currentQuestion ? this.currentQuestion.timerSound : false) || this.$store.state.settings.timerSound;
      return this.$store.state.media.mediaFiles.find(m => m.ref.fullPath.includes(sound));
    },
    leaderboard,
    status() {
      switch (this.questionState) {
        case 0:
          return "Frage durchlesen";
        case 1:
          return "Frage durchlesen";
        case 2:
          return "Antwortoptionen";
        case 3:
          return "Abstimmen";
        case 4:
          return "Ergebnisse";
      }
    }
  },
  watch: {
    percentVoted() {
      if (this.percentVoted === 1) {
        quizCollection.doc(this.quiz.id).update({
          votingEnabled: false
        });
        this.timer.start = 0;
        if (this.audio)
          this.audio.pause();
        clearInterval(this.timer.interval);
      }
    }
  },
  methods: {
    url(param) {
      return `${param ? 'https://' : ''}quiz.caritas-neuss.de/j/${this.$route.params.id}`;
    },
    shareLeaderboard() {
      return quizCollection.doc(this.quiz.id).update({
        leaderboard: this.leaderboard
      });
    },
    changeFullscreen() {
      document.onfullscreenchange = () => this.fullscreen = !this.fullscreen;

      if (this.fullscreen)
        document.exitFullscreen();
      else
        document.body.requestFullscreen();
    },
    goSteps(offset = 1) {

      this.questionState += offset;

      if (this.$refs.video)
        this.$refs.video.pause();

      if (this.audio)
        this.audio.pause();

      if (this.timerSoundMediaObject) {
        this.audio = new Audio(this.timerSoundMediaObject.url);
        this.audio.loop = true;
        this.audio.pause();
      }

      // stop timer
      if (this.timer.start) {
        this.timer.start = 0;
        clearInterval(this.timer.interval);
      }

      // disable voting of it has been enabled
      if (this.quiz.votingEnabled)
        quizCollection.doc(this.quiz.id).update({
          votingEnabled: false,
        });

      switch (this.questionState) {

          // go previous to previous question
        case -1:
          quizCollection.doc(this.quiz.id).update({
            currentQuestion: Math.min((this.quiz.currentQuestion || 0) - 1)
          });
          this.questionState = 0;
          break;

          // show video of included, else go next
        case 1:
          if (offset < 0)
            this.goSteps(-1);
          else if (this.$refs.video)
            this.$refs.video.play();
          else this.goSteps(offset < 0 ? -1 : 1)
          break;

          // start timer
        case 3:
          if (offset < 0) {
            this.goSteps(-1);
            break;
          }

          // enable voting
          quizCollection.doc(this.quiz.id).update({
            votingEnabled: true,
          });

          // if all have voted, dont start timer
          if (this.percentVoted === 1) {
            break;
          }

          if (this.currentQuestion.timerDuration === 0)
            break;

          this.timer.start = Date.now();
          this.timer.duration = this.currentQuestion.timerDuration || this.$store.state.settings.timerDuration;
          this.timer.currentValue = this.timer.duration;
          this.audio.play();
          this.timer.interval = setInterval(() => {
            this.timer.currentValue--;

            // timer ended
            if (this.timer.currentValue <= 0) {
              clearInterval(this.timer.interval);
              this.audio.pause();

              // disable voting
              quizCollection.doc(this.quiz.id).update({
                votingEnabled: false,
              });
            }
          }, 1000);
          break;

          // go to next question
        case 5:
          quizCollection.doc(this.quiz.id).update({
            currentQuestion: Math.min((this.quiz.currentQuestion || 0) + 1)
          });
          this.questionState = 0;
          break;
      }

      // before or after the quiz
      if (!this.currentQuestion) {
        this.questionState = 0;
        quizCollection.doc(this.quiz.id).update({
          currentQuestion: offset > 0 ? 0 : this.quiz.questions.length - 1
        });
      }
    },
  },
  components: { Leaderboard, VueQr }
}
</script>
<style lang="scss" scoped>
.custom-card {
  @apply bg-white p-6 rounded-xl shadow-xl border-gray-100 border;
}

.custom-card-highlight {
  @apply p-6 rounded-xl shadow-xl border-gray-100 border bg-gray-800 text-white;
}

.popup-background {
  @apply fixed top-0 left-0 w-screen h-screen bg-gray-900 bg-opacity-60 flex justify-center items-center gap-4 p-4 z-50;
}

.button {
  @apply bg-gray-200 shadow-2xl border-2 border-gray-100 rounded-full w-12 h-12 flex justify-center items-center hover:border-gray-500 active:bg-gray-300;
}

$default-card-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

.orange-bg {
  background-color: orange;
  border-color: orange;
}

.red-bg {
  background-color: red;
  border-color: red;
}

.green-inner-shadow {
  box-shadow: inset 0 0 0 6px #b5f3b5, $default-card-shadow;
  border-color: lightgreen;
}

.appear-to-right {
  animation: move linear .2s;
}

.bg-green {
  background-color: #b5f3b5;
}

@keyframes move {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

.max-h-23 {
  max-height: 30vh;
}
</style>